import { render, staticRenderFns } from "./CurrentTariff.vue?vue&type=template&id=b4f781ee&scoped=true"
import script from "./CurrentTariff.vue?vue&type=script&lang=js"
export * from "./CurrentTariff.vue?vue&type=script&lang=js"
import style0 from "./CurrentTariff.vue?vue&type=style&index=0&id=b4f781ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f781ee",
  null
  
)

export default component.exports